window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.completeApplicationBox = window.locales.am.completeApplicationBox || {};window.locales.am.completeApplicationBox = {...window.locales.am.completeApplicationBox, ...{
    "subtitle": "የእርስዎን ያጠናቅቁ",
    "title": "መተግበሪያ",
    "description": "የሚቀጥለው የመግቢያ ዑደት የመጨረሻ ቀን እየቀረበ ነው።",
    "ctaText": "የተሟላ መተግበሪያ",
    "mobileTitle": "ማመልከቻዎን ያጠናቅቁ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.completeApplicationBox = window.locales.ar.completeApplicationBox || {};window.locales.ar.completeApplicationBox = {...window.locales.ar.completeApplicationBox, ...{
    "subtitle": "أكمِل",
    "title": "طلبك",
    "description": "الموعد النهائي لدورة القبول القادمة يقترب.",
    "ctaText": "أكمِل طلبك",
    "mobileTitle": "أكمل طلبك"
}
};window.locales.en = window.locales.en || {};window.locales.en.completeApplicationBox = window.locales.en.completeApplicationBox || {};window.locales.en.completeApplicationBox = {...window.locales.en.completeApplicationBox, ...{
    "subtitle": "Complete your",
    "title": "Application",
    "description": "The deadline for the next admission cycle is approaching.",
    "ctaText": "Complete Application",
    "mobileTitle": "Complete your application"
}
};window.locales.es = window.locales.es || {};window.locales.es.completeApplicationBox = window.locales.es.completeApplicationBox || {};window.locales.es.completeApplicationBox = {...window.locales.es.completeApplicationBox, ...{
    "subtitle": "Completa tu",
    "title": "Solicitud",
    "description": "Se acerca la fecha límite para el próximo ciclo de admisión.",
    "ctaText": "Solicitud completa",
    "mobileTitle": "Completa tu solicitud"
}
};window.locales.it = window.locales.it || {};window.locales.it.completeApplicationBox = window.locales.it.completeApplicationBox || {};window.locales.it.completeApplicationBox = {...window.locales.it.completeApplicationBox, ...{
    "subtitle": "Completa la tua",
    "title": "domanda",
    "description": "La scadenza per il prossimo ciclo di ammissioni si avvicina.",
    "ctaText": "Completa la domanda",
    "mobileTitle": "Completa la tua domanda"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.completeApplicationBox = window.locales.zh.completeApplicationBox || {};window.locales.zh.completeApplicationBox = {...window.locales.zh.completeApplicationBox, ...{
    "subtitle": "完成你的",
    "title": "应用",
    "description": "下一轮招生的截止日期即将到来。",
    "ctaText": "完成申请",
    "mobileTitle": "完成申请"
}
};